/* The flags, vendored.
 *
 * These came from `https://flagcdn.com/w20/<code>.png`, fetched at render time, one request per
 * city row — so the Cities tab, the tooltip, the movement cards and the city sheet each told a
 * third party which countries a player was holding, and an installed app with no network drew a
 * broken-image glyph on every row instead of a flag. `cy-nc` was worse than that: flagcdn has no
 * such file, so Northern Cyprus has been a broken icon the whole time and nothing said so.
 *
 * They are the same w20 images, ~32KB for all 178 of them, small enough that webpack inlines every
 * one into the bundle (CRA's 10KB limit) — no requests at all, and the service worker's offline
 * launch gets them for free with the bundle it already caches.
 *
 * Generated. To add a country, drop `<code>.png` in this directory and add its line below; the
 * codes are the ISO-3166 alpha-2 ones `worldData.json` stores against each country id.
 */

import f_ae from "./ae.png"
import f_af from "./af.png"
import f_al from "./al.png"
import f_am from "./am.png"
import f_ao from "./ao.png"
import f_aq from "./aq.png"
import f_ar from "./ar.png"
import f_at from "./at.png"
import f_au from "./au.png"
import f_az from "./az.png"
import f_ba from "./ba.png"
import f_bd from "./bd.png"
import f_be from "./be.png"
import f_bf from "./bf.png"
import f_bg from "./bg.png"
import f_bi from "./bi.png"
import f_bj from "./bj.png"
import f_bm from "./bm.png"
import f_bn from "./bn.png"
import f_bo from "./bo.png"
import f_br from "./br.png"
import f_bs from "./bs.png"
import f_bt from "./bt.png"
import f_bw from "./bw.png"
import f_by from "./by.png"
import f_bz from "./bz.png"
import f_ca from "./ca.png"
import f_cd from "./cd.png"
import f_cf from "./cf.png"
import f_cg from "./cg.png"
import f_ch from "./ch.png"
import f_ci from "./ci.png"
import f_cl from "./cl.png"
import f_cm from "./cm.png"
import f_cn from "./cn.png"
import f_co from "./co.png"
import f_cr from "./cr.png"
import f_cu from "./cu.png"
import f_cy from "./cy.png"
import f_cz from "./cz.png"
import f_de from "./de.png"
import f_dj from "./dj.png"
import f_dk from "./dk.png"
import f_do from "./do.png"
import f_dz from "./dz.png"
import f_ec from "./ec.png"
import f_ee from "./ee.png"
import f_eg from "./eg.png"
import f_eh from "./eh.png"
import f_er from "./er.png"
import f_es from "./es.png"
import f_et from "./et.png"
import f_fi from "./fi.png"
import f_fj from "./fj.png"
import f_fk from "./fk.png"
import f_fr from "./fr.png"
import f_ga from "./ga.png"
import f_gb from "./gb.png"
import f_ge from "./ge.png"
import f_gf from "./gf.png"
import f_gh from "./gh.png"
import f_gl from "./gl.png"
import f_gm from "./gm.png"
import f_gn from "./gn.png"
import f_gq from "./gq.png"
import f_gr from "./gr.png"
import f_gt from "./gt.png"
import f_gw from "./gw.png"
import f_gy from "./gy.png"
import f_hn from "./hn.png"
import f_hr from "./hr.png"
import f_ht from "./ht.png"
import f_hu from "./hu.png"
import f_id from "./id.png"
import f_ie from "./ie.png"
import f_il from "./il.png"
import f_in from "./in.png"
import f_iq from "./iq.png"
import f_ir from "./ir.png"
import f_is from "./is.png"
import f_it from "./it.png"
import f_jm from "./jm.png"
import f_jo from "./jo.png"
import f_jp from "./jp.png"
import f_ke from "./ke.png"
import f_kg from "./kg.png"
import f_kh from "./kh.png"
import f_kp from "./kp.png"
import f_kr from "./kr.png"
import f_kw from "./kw.png"
import f_kz from "./kz.png"
import f_la from "./la.png"
import f_lb from "./lb.png"
import f_lk from "./lk.png"
import f_lr from "./lr.png"
import f_ls from "./ls.png"
import f_lt from "./lt.png"
import f_lu from "./lu.png"
import f_lv from "./lv.png"
import f_ly from "./ly.png"
import f_ma from "./ma.png"
import f_md from "./md.png"
import f_me from "./me.png"
import f_mg from "./mg.png"
import f_mk from "./mk.png"
import f_ml from "./ml.png"
import f_mm from "./mm.png"
import f_mn from "./mn.png"
import f_mr from "./mr.png"
import f_mt from "./mt.png"
import f_mw from "./mw.png"
import f_mx from "./mx.png"
import f_my from "./my.png"
import f_mz from "./mz.png"
import f_na from "./na.png"
import f_nc from "./nc.png"
import f_ne from "./ne.png"
import f_ng from "./ng.png"
import f_ni from "./ni.png"
import f_nl from "./nl.png"
import f_no from "./no.png"
import f_np from "./np.png"
import f_nz from "./nz.png"
import f_om from "./om.png"
import f_pa from "./pa.png"
import f_pe from "./pe.png"
import f_pg from "./pg.png"
import f_ph from "./ph.png"
import f_pk from "./pk.png"
import f_pl from "./pl.png"
import f_pr from "./pr.png"
import f_ps from "./ps.png"
import f_pt from "./pt.png"
import f_py from "./py.png"
import f_qa from "./qa.png"
import f_ro from "./ro.png"
import f_rs from "./rs.png"
import f_ru from "./ru.png"
import f_rw from "./rw.png"
import f_sa from "./sa.png"
import f_sb from "./sb.png"
import f_sd from "./sd.png"
import f_se from "./se.png"
import f_si from "./si.png"
import f_sk from "./sk.png"
import f_sl from "./sl.png"
import f_sn from "./sn.png"
import f_so from "./so.png"
import f_sr from "./sr.png"
import f_ss from "./ss.png"
import f_sv from "./sv.png"
import f_sy from "./sy.png"
import f_sz from "./sz.png"
import f_td from "./td.png"
import f_tf from "./tf.png"
import f_tg from "./tg.png"
import f_th from "./th.png"
import f_tj from "./tj.png"
import f_tl from "./tl.png"
import f_tm from "./tm.png"
import f_tn from "./tn.png"
import f_tr from "./tr.png"
import f_tt from "./tt.png"
import f_tw from "./tw.png"
import f_tz from "./tz.png"
import f_ua from "./ua.png"
import f_ug from "./ug.png"
import f_us from "./us.png"
import f_uy from "./uy.png"
import f_uz from "./uz.png"
import f_ve from "./ve.png"
import f_vn from "./vn.png"
import f_vu from "./vu.png"
import f_xk from "./xk.png"
import f_ye from "./ye.png"
import f_za from "./za.png"
import f_zm from "./zm.png"
import f_zw from "./zw.png"

const FLAGS = {
  "ae": f_ae,
  "af": f_af,
  "al": f_al,
  "am": f_am,
  "ao": f_ao,
  "aq": f_aq,
  "ar": f_ar,
  "at": f_at,
  "au": f_au,
  "az": f_az,
  "ba": f_ba,
  "bd": f_bd,
  "be": f_be,
  "bf": f_bf,
  "bg": f_bg,
  "bi": f_bi,
  "bj": f_bj,
  "bm": f_bm,
  "bn": f_bn,
  "bo": f_bo,
  "br": f_br,
  "bs": f_bs,
  "bt": f_bt,
  "bw": f_bw,
  "by": f_by,
  "bz": f_bz,
  "ca": f_ca,
  "cd": f_cd,
  "cf": f_cf,
  "cg": f_cg,
  "ch": f_ch,
  "ci": f_ci,
  "cl": f_cl,
  "cm": f_cm,
  "cn": f_cn,
  "co": f_co,
  "cr": f_cr,
  "cu": f_cu,
  "cy": f_cy,
  "cz": f_cz,
  "de": f_de,
  "dj": f_dj,
  "dk": f_dk,
  "do": f_do,
  "dz": f_dz,
  "ec": f_ec,
  "ee": f_ee,
  "eg": f_eg,
  "eh": f_eh,
  "er": f_er,
  "es": f_es,
  "et": f_et,
  "fi": f_fi,
  "fj": f_fj,
  "fk": f_fk,
  "fr": f_fr,
  "ga": f_ga,
  "gb": f_gb,
  "ge": f_ge,
  "gf": f_gf,
  "gh": f_gh,
  "gl": f_gl,
  "gm": f_gm,
  "gn": f_gn,
  "gq": f_gq,
  "gr": f_gr,
  "gt": f_gt,
  "gw": f_gw,
  "gy": f_gy,
  "hn": f_hn,
  "hr": f_hr,
  "ht": f_ht,
  "hu": f_hu,
  "id": f_id,
  "ie": f_ie,
  "il": f_il,
  "in": f_in,
  "iq": f_iq,
  "ir": f_ir,
  "is": f_is,
  "it": f_it,
  "jm": f_jm,
  "jo": f_jo,
  "jp": f_jp,
  "ke": f_ke,
  "kg": f_kg,
  "kh": f_kh,
  "kp": f_kp,
  "kr": f_kr,
  "kw": f_kw,
  "kz": f_kz,
  "la": f_la,
  "lb": f_lb,
  "lk": f_lk,
  "lr": f_lr,
  "ls": f_ls,
  "lt": f_lt,
  "lu": f_lu,
  "lv": f_lv,
  "ly": f_ly,
  "ma": f_ma,
  "md": f_md,
  "me": f_me,
  "mg": f_mg,
  "mk": f_mk,
  "ml": f_ml,
  "mm": f_mm,
  "mn": f_mn,
  "mr": f_mr,
  "mt": f_mt,
  "mw": f_mw,
  "mx": f_mx,
  "my": f_my,
  "mz": f_mz,
  "na": f_na,
  "nc": f_nc,
  "ne": f_ne,
  "ng": f_ng,
  "ni": f_ni,
  "nl": f_nl,
  "no": f_no,
  "np": f_np,
  "nz": f_nz,
  "om": f_om,
  "pa": f_pa,
  "pe": f_pe,
  "pg": f_pg,
  "ph": f_ph,
  "pk": f_pk,
  "pl": f_pl,
  "pr": f_pr,
  "ps": f_ps,
  "pt": f_pt,
  "py": f_py,
  "qa": f_qa,
  "ro": f_ro,
  "rs": f_rs,
  "ru": f_ru,
  "rw": f_rw,
  "sa": f_sa,
  "sb": f_sb,
  "sd": f_sd,
  "se": f_se,
  "si": f_si,
  "sk": f_sk,
  "sl": f_sl,
  "sn": f_sn,
  "so": f_so,
  "sr": f_sr,
  "ss": f_ss,
  "sv": f_sv,
  "sy": f_sy,
  "sz": f_sz,
  "td": f_td,
  "tf": f_tf,
  "tg": f_tg,
  "th": f_th,
  "tj": f_tj,
  "tl": f_tl,
  "tm": f_tm,
  "tn": f_tn,
  "tr": f_tr,
  "tt": f_tt,
  "tw": f_tw,
  "tz": f_tz,
  "ua": f_ua,
  "ug": f_ug,
  "us": f_us,
  "uy": f_uy,
  "uz": f_uz,
  "ve": f_ve,
  "vn": f_vn,
  "vu": f_vu,
  "xk": f_xk,
  "ye": f_ye,
  "za": f_za,
  "zm": f_zm,
  "zw": f_zw,
}

/* A code with no file is not an error worth throwing over: the world map carries a couple of
   territories nobody publishes a flag for, and a missing flag should cost the flag, not the row.
   Every caller renders the `<img>` only when this answers. */
export const flagFor = (code) => (code ? FLAGS[code] : undefined)

export default FLAGS
